import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { Button } from "@radix-ui/themes";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { FC, useCallback } from "react";
import { useParams } from "react-router";

export const SpaceAccountAppCalloutsViewPage: FC = () => {
  // const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { spaceAccountAppCalloutId } = useParams<{ spaceAccountAppCalloutId: Uuid }>();

  if (!spaceAccountAppCalloutId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["space-account-app-callout-by-id", spaceAccountAppCalloutId],
    queryFn: () =>
      api.get("/internal/v1/space-account-app-callouts/{space_account_app_callout_id}", {
        params: {
          path: {
            space_account_app_callout_id: spaceAccountAppCalloutId,
          },
        },
      }),
  });

  const patchSpaceAccountAppCallout = useCallback(
    async ({ dismissedAt }: { dismissedAt?: DateTime }) => {
      const confirmed = confirm(
        `Are you sure you want to patch space account app callout with the following values: ${JSON.stringify(
          {
            dismissedAt,
          },
          (_, value) => (value === undefined ? "undefined" : value)
        )}?`
      );

      if (!confirmed) {
        return;
      }

      await api.patch("/internal/v1/space-account-app-callouts/{space_account_app_callout_id}", {
        params: {
          path: {
            space_account_app_callout_id: spaceAccountAppCalloutId,
          },
        },
        body: {
          dismissed_at: dismissedAt?.toISO(),
        },
      });

      await queryClient.invalidateQueries({
        queryKey: ["space-account-app-callout-by-id", spaceAccountAppCalloutId],
      });
    },
    [spaceAccountAppCalloutId]
  );

  const markForceUpgradeRequiredAsTrue = useCallback(() => {
    patchSpaceAccountAppCallout({
      dismissedAt: DateTime.now(),
    });
  }, [patchSpaceAccountAppCallout]);

  const markForceUpgradeRequiredAsFalse = useCallback(() => {
    patchSpaceAccountAppCallout({
      dismissedAt: undefined,
    });
  }, [patchSpaceAccountAppCallout]);

  /**
   * We can roll this out after OpenAPI typings are updated + deployed..
   */
  // const handleViewSpaceAccount = useCallback(() => {
  //   if (!result.data?.data.) {
  //     return;
  //   }

  //   navigate(
  //     atlasRoutes.spaceAccountsView({ params: { spaceAccountId: result.data?.space_account_id } })
  //       .path
  //   );
  // }, [result.data?.space_account_id]);

  // const handleViewAppCallout = useCallback(() => {
  //   if (!result.data?.app_callout_id) {
  //     return;
  //   }

  //   navigate(
  //     atlasRoutes.appCalloutsView({ params: { appCalloutId: result.data?.app_callout_id } }).path
  //   );
  // }, [result.data?.app_callout_id]);

  return (
    <div>
      <h1>View Space Account App Callout</h1>

      {/* <Button variant="outline" onClick={() => handleViewSpaceAccount()}>
        View Space Account
      </Button>

      <Button variant="outline" onClick={() => handleViewAppCallout()}>
        View App Callout
      </Button> */}

      <Button variant="outline" onClick={markForceUpgradeRequiredAsTrue}>
        Mark Dismissed as True
      </Button>
      <br />
      <Button variant="outline" onClick={markForceUpgradeRequiredAsFalse}>
        Mark Dismissed as False
      </Button>
      <br />
      <br />
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
    </div>
  );
};
